export enum PlaybooksSupportedActions {
    Disable = "disable",
    Enable = "enable",
    Delete = "delete",
    Edit = "edit",
    Duplicate = "duplicate",
    View = "view",
}
